import { categoriesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories";
// import { imageStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsImage";
import { logoStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsLogo";
import { productLinesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsProductLines";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { imageStyles } from "@tCooneyBrothers/Overrides/Widgets/BrandDetails/BrandDetailsImage";
import { css } from "styled-components";

categoriesStyles.subCategoryItem = {
    css: css`
        flex-basis: 100%;
        max-width: 100%;
        ~ [class^="GridItemStyle"] {
            justify-content: center;
        }
    `,
};

categoriesStyles.categoryImageItem = {
    width: 12,
    align: "middle",
    css: css`
        width: 100%;
        height: 160px;
        justify-content: center;
        margin-top: 20px !important;
        div[class^="LazyImageStyle"] {
            overflow: hidden;
            border: 1px solid rgb(201, 201, 201);
            border-radius: 50%;
            background: rgb(255, 255, 255);
            width: 160px;
            height: 160px;
            margin-bottom: 10px;
            img {
                max-width: 70% !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 135px;
                            height: 135px;
                        `,
                        css`
                            width: 135px;
                            height: 135px;
                        `,
                        css`
                            width: 135px;
                            height: 135px;
                        `,
                    ],
                    "max",
                )}
        }
    `,
};

categoriesStyles.categoryNameLink = {
    typographyProps: {
        variant: "h3",
        weight: "bold",
        css: css`
            width: 100%;
            overflow-wrap: break-word;
            word-wrap: break-word;
            font-size: 13px;
            text-transform: none;
            margin-bottom: inherit;
        `,
    },
    color: "text.main",
    css: css`
        width: 100%;
        text-align: center;
    `,
};

categoriesStyles.subCategoryLink = {
    typographyProps: {
        variant: "h4",
        css: css`
            font-size: 13px;
            font-weight: inherit;
            width: 100%;
            overflow-wrap: break-word;
            word-wrap: break-word;
            margin-bottom: inherit;
        `,
    },
    css: css`
        width: 100%;
        text-align: center;
    `,
};

imageStyles.productLinkItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        justify-content: center !important;
                        margin-bottom: 15px !important;
                    `,
                    css`
                        justify-content: center !important;
                        margin-bottom: 15px !important;
                    `,
                    null,
                ],
                "max",
            )}
        a[data-test-selector="brandToProductPageLink"] {
            padding: 7px 21px 5px;
            background: #58b46c;
            border: 2px solid #58b46c;
            color: rgb(255, 255, 255);
            display: flex;
            align-items: center;
            justify-content: center;
            &:hover {
                background: #3a814a;
                border-color: #3a814a;
            }
            span {
                color: #000000;
                text-transform: uppercase;
            }
        }
    `,
};

imageStyles.container = {
    css: css`
        div[class^="GridOffset"] {
            margin: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                            margin: 0;
                            justify-content: center;
                            > h1 {
                                margin: 0;
                            }
                        `,
                        css`
                            width: 100%;
                            margin: 0;
                            justify-content: center;
                            > h1 {
                                margin: 0;
                            }
                        `,
                        null,
                    ],
                    "max",
                )}
            justify-content: space-between;
            padding-left: 4px;
            
           > h1 {
            padding-left: 11px;
            color: #474747;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding-left: 0;
                            `,
                            css`
                                padding-left: 0;
                            `,
                            null,
                        ],
                        "max",
                    )}
            }
        div[class^="GridItemStyle"] {
            padding-bottom: 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 15px 0 5px 0;
                        `,
                        css`
                            padding: 15px 0 5px 0;
                        `,
                        null,
                    ],
                    "max",
                )}
            h3 {
                display: none;
            }
            [class^="GridWrapper"] {
                padding: 0;
            }
        }
    `,
};

logoStyles.container = {
    css: css`
        max-width: 300px;
        margin: 15px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        margin: 15px auto;
                    `,
                    css`
                        margin: 15px auto;
                    `,
                    null,
                ],
                "max",
            )}
    `,
};

imageStyles.heading = {
    variant: "h1",
    css: css`
        overflow-wrap: break-word;
        word-wrap: break-word;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        text-align: center;
                        padding-top: 30px;
                        margin-left: 30%;
                    `,
                    css`
                        text-align: center;
                        padding-top: 30px;
                        margin-left: 30%;
                    `,
                    null,
                ],
                "max",
            )}
    `,
};

categoriesStyles.title = {
    as: "h2",
    variant: "headerSecondary",
    transform: "inherit",
    css: css`
        text-transform: uppercase;
        color: rgb(46, 100, 176);
        font-size: 24px;
        font-weight: 700;
        display: block;
        margin-bottom: 10px;
        border-width: 20px;
    `,
};

productLinesStyles.title = {
    variant: "h2",
    css: css`
        text-transform: uppercase;
        color: #2e64b0;
        font-size: 24px;
        font-weight: 700;
        display: block;
        margin-bottom: 10px;
        border-width: 20px;
    `,
};

productLinesStyles.titleItem = {
    width: 12,
    css: css`
        width: 100%;
        justify-content: left;
        h2 {
            color: #2e64b0;
        }
    `,
};

productLinesStyles.productLineItemRow = {
    width: [6, 6, 3, 3, 3],
};

productLinesStyles.productLineImageItem = {
    width: 12,
    align: "middle",
    css: css`
        width: 100%;
        height: auto;
        justify-content: center;
    `,
};

productLinesStyles.productLineName = {
    weight: "bold",
    variant: "h3",
    css: css`
        width: 100%;
        overflow-wrap: break-word;
        word-wrap: break-word;
        text-align: center;
        font-size: 13px;
        text-transform: none;
    `,
    color: "text.main",
};
productLinesStyles.productLineImageClickable = {
    css: css`
        [data-test-selector^="brandProductLineImage"] {
            align-items: flex-start;
        }
        img {
            height: 100%;
            margin-bottom: 10px;
        }
    `,
};
